import React from 'react';
import PropTypes from 'prop-types';
import { eventPropType } from '../../Constants/eventTypes';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';
import eventSelectList from '../../Helpers/EventSelectList';
import SelectList from '../SelectList';

const EventTypeSelectField = ({ types, input, meta }) => (
  <div className="mt-4">
    <label
      htmlFor={input.name}
      className={`h4 mb-4 text-center${
        meta.touched && meta.error && ' form-error__label'
      }
        `}
    >
      Other event types
    </label>
    {meta.touched && meta.error && (
      <div className="form-error">{meta.error}</div>
    )}
    <SelectList
      options={eventSelectList(types).map((type) => ({
        value: type.identifier,
        label: type.name,
      }))}
      input={input}
      placeholder="Select from the list"
      searchable
    />
  </div>
);

EventTypeSelectField.propTypes = {
  types: PropTypes.arrayOf(eventPropType).isRequired,
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
};

export default EventTypeSelectField;
